
import React, { useState, useEffect } from 'react';



function ClockDisplayComponent() {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const formattedTime = currentTime.toUTCString().slice(17, 25); 

  const formattedDate = currentTime.toUTCString().slice(0, 16); 

  return (
    <div className="flex flex-col items-end">
    <div className="text-xl font-medium">{formattedTime}</div>
    <div className="text-xs text-white">{formattedDate}</div>
  </div>
  );
}

export default ClockDisplayComponent;
